import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './offerCard.scss'
function OfferCard(props) {
  const [offersInfo, updateoffersInfo] = useState({
    title: '',
    keywords: [],
    summary: '',
    offerIndex: '',
  });
  useEffect(() => {
    if (props && props.offer) {
      const { offer } = props;
      const keywords = [];
      offer.workPlace && keywords.push(offer.workPlace);
      offer.jobType && keywords.push(offer.jobType);
      offer.sarary && keywords.push(offer.sarary);
      const summary = offer.roles ? JSON.parse(offer.roles).content || '' : '';
      updateoffersInfo({
        title: offer.offerTitle || '',
        keywords,
        summary: summary.replace(/<img.*?(?:>|\/>)/gi, ''),
        offerIndex: offer.offerIndex || '',
      });
    }
  }, [props]);

  useEffect(() => {
    if (offersInfo.offerIndex) {
      const moduleContentDoc = document.querySelector(`.coverContent${offersInfo.offerIndex}`);
      moduleContentDoc.innerHTML = offersInfo.summary;
    }
  }, [offersInfo.summary, offersInfo.offerIndex]);

  return (
    <div className="offerCard">
      <Link
        to={`/recruitmentDetails/${offersInfo.offerIndex}`}
      >
        <h3 className='offerInfoTitle'>
          <span className='titleTitle'>{offersInfo.title}</span>
          <span className='titleIcon'>
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L8 7.5L1 14" stroke="#071139" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L8 7.5L1 14" stroke="#071139" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>

        </h3>
        <div className='offerListKeyWords'>
          {offersInfo.keywords.map((item) => (
            <div
              key={item}
              className="KeyWords"
            >
              <span>
                {item}
              </span>
            </div>
          ))}
        </div>
        <p className={`coverContent coverContent${offersInfo.offerIndex}`}>
        </p>
      </Link>
    </div>
  );
}

export default OfferCard;
